import "styles/global.scss";
import "styles/bootstrap-table.scss";
import "styles/dark-mode-slider.scss";
import "styles/edhrec-ui.scss";
import "styles/mediavine.scss";
import "styles/navbar.scss";
import "styles/dark.scss";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-loading-skeleton/dist/skeleton.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faCalculator,
  faCheck,
  faCircle,
  faCog,
  faCrown,
  faDragon,
  faEnvelope,
  faEye,
  faLink,
  faMoon,
  faNewspaper,
  faPaperclip,
  faPlus,
  faPodcast,
  faQuestion,
  faRandom,
  faRssSquare,
  faRotateLeft,
  faSearch,
  faShirt,
  faSpinner,
  faSun,
  faTimes,
  faTimesCircle,
  faTrash,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import firebase from "firebase/compat/app";
import React from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { createFirestoreInstance } from "redux-firestore";
import { PersistGate } from "redux-persist/integration/react";
import useDarkMode from "use-dark-mode";

import Router from "components/Router/Router";
import configureStore from "store/configureStore";

React.useLayoutEffect = React.useEffect; // Silence BrowserRouter error

const { persistor, store } = configureStore();

if (firebase.apps.length === 0) {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  };
  firebase.initializeApp(firebaseConfig);
  firebase.firestore();
}

const App = () => {
  const darkMode = useDarkMode(false);

  library.add(
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faCalculator,
    faCheck,
    faCircle,
    faCog,
    faCrown,
    faDragon,
    faEnvelope,
    faEye,
    faLink,
    faMoon,
    faNewspaper,
    faPaperclip,
    faPlus,
    faPodcast,
    faQuestion,
    faRandom,
    faRotateLeft,
    faRssSquare,
    faSearch,
    faShirt,
    faSpinner,
    faSun,
    faTimes,
    faTimesCircle,
    faTrash,
    faUser,
    fab
  );

  return (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ReactReduxFirebaseProvider
            config={{
              preserveOnLogin: { profile: true },
              useFirestoreForProfile: true,
              userProfile: "users",
            }}
            createFirestoreInstance={createFirestoreInstance}
            dispatch={store.dispatch}
            firebase={firebase}
          >
            <SkeletonTheme
              baseColor={darkMode.value ? "#888" : null}
              highlightColor={darkMode.value ? "#adb5bd" : null}
            >
              <Router />
            </SkeletonTheme>
          </ReactReduxFirebaseProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
